/**
 * Footer function
 * 1st click on parent link -> opens submenu (prevents navigation)
 * 2nd click on the same parent link -> navigates
 * Clicks inside .sub-menu -> always navigate
 * Click outside -> close all
 */
export const footerFunction = () => {

	const footer = document.querySelector( 'footer.page-footer' );
	const menu   = footer?.querySelector( '.page-footer__up-menu-menu' );
	if ( !footer || !menu ) {

		return;

	}

	/**
	 *
	 */
	const closeAll = () => {

		menu.querySelectorAll( '.menu-item-has-children.is-active' ).forEach( li => {

			li.classList.remove( 'is-active' );
			li.querySelectorAll( ':scope > a,[aria-expanded]' ).forEach( t => t.setAttribute( 'aria-expanded', 'false' ) );
			li.querySelectorAll( ':scope > .sub-menu' ).forEach( ul => ul.classList.remove( 'is-active' ) );

		} );

	};
	/**
	 *
	 * @param {HTMLElement} li
	 */
	const openItem = ( li ) => {

		li.classList.add( 'is-active' );
		const sub = li.querySelector( ':scope > .sub-menu' );
		const a  = li.querySelector( ':scope > a' );
		if ( sub ) {

			sub.classList.add( 'is-active' );

		}
		if ( a ) {

			a.setAttribute( 'aria-expanded', 'true' );

		}

	};
	/**
	 *
	 * @param {HTMLElement} li
	 * @param {boolean|null} forceOpen
	 *
	 * @return {boolean} true if the item is now open, false if closed
	 */
	const toggleItem = ( li, forceOpen = null ) => {

		const isOpen = li.classList.contains( 'is-active' );
		if ( forceOpen === true || ( !isOpen && forceOpen === null ) ) {

			li.parentElement?.querySelectorAll( ':scope > .menu-item-has-children.is-active' ).forEach( sib => {

				if ( sib !== li ) {

					sib.classList.remove( 'is-active' );
					sib.querySelector( ':scope > a' )?.setAttribute( 'aria-expanded', 'false' );
					sib.querySelector( ':scope > .sub-menu' )?.classList.remove( 'is-active' );

				}

			} );
			openItem( li );
			return true;

		}

		li.classList.remove( 'is-active' );
		li.querySelector( ':scope > a' )?.setAttribute( 'aria-expanded', 'false' );
		li.querySelector( ':scope > .sub-menu' )?.classList.remove( 'is-active' );
		return false;

	};

	menu.addEventListener( 'click', ( event ) => {

		const target = event.target;

		const parentLink = target.closest( '.menu-item-has-children > a' );
		if ( parentLink && menu.contains( parentLink ) ) {

			const li = parentLink.parentElement;
			const wasOpen = li.classList.contains( 'is-active' );

			if ( !wasOpen ) {


				event.preventDefault();
				toggleItem( li, true );

			} else {


				closeAll();

			}
			return;

		}


		const insideSubmenu = target.closest( '.sub-menu' );
		if ( insideSubmenu && menu.contains( insideSubmenu ) ) {


		}

	} );


	menu.addEventListener( 'keydown', ( event ) => {

		const key = event.key;
		if ( key !== 'Enter' && key !== ' ' ) {

			return;

		}
		const parentLink = event.target.closest( '.menu-item-has-children > a' );
		if ( !parentLink ) {

			return;

		}
		event.preventDefault();
		const li = parentLink.parentElement;
		const wasOpen = li.classList.contains( 'is-active' );
		if ( !wasOpen ) {

			toggleItem( li, true );

		} else {


			parentLink.click();

		}

	} );


	document.addEventListener( 'click', ( event ) => {

		if ( !menu.contains( event.target ) ) {

			closeAll();

		}

	} );

};
